import script from "./ContentMetadata.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentMetadata.vue?vue&type=script&lang=ts&setup=true"

import "./ContentMetadata.vue?vue&type=style&index=0&id=66c9dd75&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66c9dd75"]])

export default __exports__